import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

export const simpleSwapCcrProxySupportedChains = [
    BLOCKCHAIN_NAME.SCROLL,
    BLOCKCHAIN_NAME.ETHEREUM,
    BLOCKCHAIN_NAME.ARBITRUM,
    BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN,
    BLOCKCHAIN_NAME.BLAST,
    BLOCKCHAIN_NAME.BASE,
    BLOCKCHAIN_NAME.MANTA_PACIFIC,
    BLOCKCHAIN_NAME.KAVA,
    BLOCKCHAIN_NAME.POLYGON,
    BLOCKCHAIN_NAME.AVALANCHE,
    BLOCKCHAIN_NAME.FANTOM,
    BLOCKCHAIN_NAME.MOONRIVER,
    BLOCKCHAIN_NAME.HARMONY,
    BLOCKCHAIN_NAME.OPTIMISM,
    BLOCKCHAIN_NAME.TELOS,
    BLOCKCHAIN_NAME.CRONOS,
    BLOCKCHAIN_NAME.MOONBEAM,
    BLOCKCHAIN_NAME.CELO,
    BLOCKCHAIN_NAME.METIS,
    BLOCKCHAIN_NAME.KLAYTN,
    BLOCKCHAIN_NAME.VELAS,
    BLOCKCHAIN_NAME.SYSCOIN,
    BLOCKCHAIN_NAME.IOTEX,
    BLOCKCHAIN_NAME.LINEA,
    BLOCKCHAIN_NAME.MANTLE,
    BLOCKCHAIN_NAME.MODE,
    BLOCKCHAIN_NAME.ZETACHAIN,
    BLOCKCHAIN_NAME.SEI,
    BLOCKCHAIN_NAME.TAIKO,
    BLOCKCHAIN_NAME.CORE,
    BLOCKCHAIN_NAME.ZK_LINK,
    BLOCKCHAIN_NAME.ZK_SYNC,
    BLOCKCHAIN_NAME.MERLIN
];

export type SimpleSwapCcrProxySupportedChains = (typeof simpleSwapCcrProxySupportedChains)[number];
